
<template>
  <v-card flat
          class="grey--text text--darken-4">
      <v-card-actions class="pa-0 card-wrap" :class="filteredRankingBoards.length == 3 ? 'justify1': 'justify2'">
        <div
          v-for="(item, index) in filteredRankingBoards"
          :key="index"
          @click="chooseCurrent(item.id)"
          :class="{ current: currentCard === item.id}"
          class="title-md mb-3"
        >
          <a class="dashboard-title">{{ item.title }}</a>
        </div>
      </v-card-actions>
      <div v-if="currentCard === 1">
        <div class="display-flex justify-content-between">
          <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.Ranking==0?'—':rank.Ranking }}</span>
              <span>Ranking</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ parseIntCon(rank.Conversion) }}%</span>
              <span>Conversion Ratio</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.TrailTotal==0?'0':rank.TrailTotal }}</span>
              <span>Completed Trials</span>
            </div>
        </div>

        <div class="update-time pt-4 blue-title">
          <v-btn class="text-none height24 blue-button" @click="redirectToRankPage('top')">Enter</v-btn> 
          <div>
            Update time： <span class="blue-title-2">{{rank.NowUpdateTime | formatDate}}</span></div>
        </div>
      </div>

      <div v-if="currentCard === 2">
        <div class="display-flex justify-content-between">
          <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.AllocateRanking == 0 ? '—' : rank.AllocateRanking }}</span>
              <span>Ranking</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.DD_AllocateClass_Num == 0 ? '—' : rank.DD_AllocateClass_Num }}</span>
              <span>Number of Orders Received</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span></span>
              <span></span>
            </div>
        </div>

        <div class="update-time pt-4 blue-title">
          <v-btn class="text-none height24 blue-button" @click="redirectToRankPage('dd1')">Enter</v-btn> 
          <div>
            Update time： <span class="blue-title-2">{{rank.LastUpdateTime | formatDate}}</span></div>
        </div>
      </div>

      <div v-if="currentCard === 3">
        <div class="display-flex justify-content-between">
          <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.ResponseRanking == 0 ? '—' : rank.ResponseRanking }}</span>
              <span>Ranking</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.ResponseOrderClass_10s_Num == 0 ? '0' : rank.ResponseOrderClass_10s_Num }}</span>
              <span>10 Seconds to Receive Orders</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.RemindOrderClass_Num == 0 ? '0' : rank.RemindOrderClass_Num }}</span>
              <span>Reminder Frequency</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ parseIntCon(rank.ResponseOrderClass_10s_Rate) }}%</span>
              <span>Ratio</span>
            </div>
            
        </div>

        <div class="update-time pt-4 blue-title">
          <v-btn class="text-none height24 blue-button" @click="redirectToRankPage('dd2')">Enter</v-btn> 
          <div>
            Update time： <span class="blue-title-2">{{rank.LastUpdateTime | formatDate}}</span></div>
        </div>
      </div>

      <div v-if="currentCard === 4">
        <div class="display-flex justify-content-between">
          <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.Ranking == 0 ? '—' : rank.Ranking }}</span>
              <span>Ranking</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.OverCount == 0 ? '0' : rank.OverCount }}</span>
              <span>Effective completion of courses</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.AllScore == 0 ? '0' : rank.AllScore }}</span>
              <span>Effective total score</span>
            </div>
            <div class="dashboard-subtitle display-flex align-items-center flex-direction-column">
              <span>{{ rank.AvgScore }}</span>
              <span>Average score</span>
            </div>
            
        </div>

        <div class="update-time pt-4 blue-title">
          <v-btn class="text-none height24 blue-button" @click="redirectToRankPage('emotion')">Enter</v-btn> 
          <div>
            Update time： <span class="blue-title-2">{{rank.LastUpdateTime | formatDate}}</span></div>
        </div>
      </div>
        
  </v-card>
</template>
<script>
import { getRankingSummary } from '@/api/tutordata.js'
import { formatDate } from '@/utils/date.js'

export default {
  data: () => ({
    rank:{},
    currentCard: 0,
    rankingBoards: [
      { id: 1, title: 'Trial Class Ranking Board', isShow: false },
      { id: 2, title: 'Received Orders Ranking Board', isShow: false },
      { id: 3, title: '10s Response Rate Ranking Board', isShow: false },
      { id: 4, title: 'Emotional Motivation Ranking', isShow: false },
    ],
    rankingSummary:{}

  }),
  computed: {
    filteredRankingBoards() {
      return this.rankingBoards.filter(board => board.isShow);
    }
  },
  filters:{
    formatDate(time) {
        return formatDate(time, "MM/dd/yyyy hh:mm");
    }
  },
  async mounted () {

    const configMap = {
      1: 'IsShowTopTutorRanking',      // 试听课榜单
      2: 'IsShowDidiRanking',          // Didi
      3: 'IsShowDidiRanking',          // Didi
      4: 'IsShowCourseFeelRanking'     // 情绪分
    }

    getRankingSummary().then(res => {
      if(res.data.ErrorCode==0){
        this.rankingSummary = res.data.Body
        this.rankingBoards.forEach(board => {
          const configKey = configMap[board.id];
          if (configKey) {
            board.isShow = this.rankingSummary[configKey];
          }
          // board.isShow = board.id === 1 ? this.rankingSummary.IsShowTopTutorRanking : [2, 3].includes(board.id) ? this.rankingSummary.IsShowDidiRanking : board.isShow
        })
      }
    })
  },
  methods: {
    redirectToRankPage (type) {
      switch (type) {
        case 'top':
          this.$router.push({
            path: `/conversionRanking`
          })
          break;
        case 'dd1':
          this.$router.push({
            path: `/receivedOrdersRanking`
          })
          break;
        case 'dd2':
          this.$router.push({
            path: `/10sResponseRateRanking`
          })
          break;
        case 'emotion':
          this.$router.push({
            path: `/emotionalMotivationRanking`
          })
          break;
        default:
      }
      
    },
    parseIntCon(num){
      return (num*100).toFixed(2)
    },
    chooseCurrent(id){
      this.currentCard = id
      this.setCurrentTabData(id);
      
    },
    setCurrentTabData(id) {
      
      if (id === 1) {
        this.rank = this.rankingSummary.TopTutorRankingData
      } else if ([2, 3].includes(id)) {
        this.rank = this.rankingSummary.DidiRankingData
      } else if(id === 4 ){
        this.rank = this.rankingSummary.CourseFeelRankingData
      }
    }
  },
    
  watch:{
    'filteredRankingBoards':function(){
      this.chooseCurrent(this.filteredRankingBoards[0].id);
    }
  }
}
</script>
<style lang="scss" scoped>
.title-text>a:hover{
  text-decoration: underline;
}
.update-time{
  display: flex;
  justify-content: space-between;
  .v-btn{
    margin: 0;
  }
}
.card-wrap{
  display: flex;
  justify-content: start;
  &.justify1{
    justify-content: space-between;
  }
  &.justify2{
    .title-md{
      margin-right: 1%;
    }
  }
  .title-md{
    border: 1px solid #3E67FB;
    padding: 0 10px;
    border-radius: 6px;
    height: 30px;
    overflow: hidden;
    &.current{
      background:#3E67FB;
      a{
        color: #fff!important;
      }
    }
    .dashboard-title{
      font-size: 14px;
      color:#3E67FB!important;
    }
  }
}
</style>
